import type { BenchmarkRecommendedJobType, BenchmarkResultPayloadType } from "@/types";
import {
    getStorageItemHandler,
    removeStorageItemHandler,
    setStorageItemHandler,
    storageKeys,
} from "@/utils/storage";

export interface CachedBenchmarkResultInterface {
    industry: string,
    jobDescription: string,
    jobId: string,
    jobTitle: string,
    recommendedJobs: BenchmarkRecommendedJobType[],
    resultPayload: BenchmarkResultPayloadType,
    seniority: string,
}

interface CacheEnvelopeInterface {
    result: CachedBenchmarkResultInterface,
    savedAt: number,
}

const cacheTtlMs = 60 * 60 * 1000;

export const saveBenchmarkResultCacheHandler = (result: CachedBenchmarkResultInterface): void => {
    setStorageItemHandler<CacheEnvelopeInterface>(
        storageKeys.cachedBenchmarkResult,
        {
            result,
            savedAt: Date.now(),
        },
    );
};

export const loadBenchmarkResultCacheHandler = (): CachedBenchmarkResultInterface | null => {
    const envelope = getStorageItemHandler<CacheEnvelopeInterface>(storageKeys.cachedBenchmarkResult);

    if (!envelope) return null;

    if (Date.now() - envelope.savedAt > cacheTtlMs) {
        removeStorageItemHandler(storageKeys.cachedBenchmarkResult);

        return null;
    }

    return envelope.result;
};

export const clearBenchmarkResultCacheHandler = (): void => removeStorageItemHandler(storageKeys.cachedBenchmarkResult);
